import { render, staticRenderFns } from "./RadarCreator.vue?vue&type=template&id=397234d6&scoped=true&"
import script from "./RadarCreator.vue?vue&type=script&lang=js&"
export * from "./RadarCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397234d6",
  null
  
)

export default component.exports